
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import UpdateButton from '@/components/UpdateButton.vue';

@Component({
  components: {
    UpdateButton,
  },
})
export default class ConnectionEditDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean

  // Il titolo del dialog
  @Prop({ type: String, default: null }) readonly title!: string | null

  // La larghezza massima del dialog
  @Prop({ type: String, default: '600' }) readonly maxWidth!: string

  dialog = false

  // TODO: Ha senso veridicare la validità del form? Al momento non lo faccio
  valid = false

  // La Connection è in caricamento?
  get loading(): boolean {
    return this.$store.getters.isConnectionLoading;
  }

  // È necessario salvare le modifiche alla Connection?
  get dirty(): boolean {
    return this.$store.getters.isConnectionDirty;
  }

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }

    // Se stiamo chiudendo il dialog, deseleziona la Connection
    if (!val) {
      this.$store.dispatch('unselectConnection');
    }
  }

  onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    // Chiude il dialog
    this.dialog = false;

    // Comunica al componente padre che le modifiche sono state annullate
    this.$emit('cancel');
  }

  onSave() {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    // Salva in background — dispatch cattura this.update e currentConnectionId
    // sincrono fino al primo await, prima che il watcher su dialog possa svuotarli
    this.$store.dispatch('updateSelectedConnection');

    // Chiude il dialog subito (lo store è già aggiornato ottimisticamente)
    this.dialog = false;

    // Comunica al componente padre che le modifiche sono state salvate
    this.$emit('save');
  }
}
